<template>
  <div class="results-array">
    <modal v-model="focusModal.show" size="full"
           :footer="false" :header="false">
      <div v-if="focusModal.show">
        <sui-evol-carac :sources="focusModal.sources"
                        :field-info="focusModal.fieldInfo">
        </sui-evol-carac>
      </div>
    </modal>
    <modal v-model="filterModal.show" title="Liste de filtres" size="lg"
           @hide="updateArray">
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label>Filtre</label>
            <input id="filter" tabindex="1" class="form-control"
                   v-model.trim="filterModal.edit.filter" type="text"
                   placeholder="Filtre"/>
          </div>
          <div class="form-group">
            <label>Nom</label>
            <input id="nom" tabindex="2" class="form-control"
                   v-model.trim="filterModal.edit.name" type="text"
                   @keyup.enter="saveFilter"
                   placeholder="Nom"/>
          </div>
          <btn @click="saveFilter"
               :disabled="filterModal.edit.filter === '' || filterModal.edit.name ===''">
            Appliquer
          </btn>
          <hr>
          <label>Réinitialiser à partir d'une variable</label>
          <div class="form-group">
            <input :id="`variable-${_uid}`" class="form-control" type="text"
                   v-model="filterModal.variable.text" autocomplete="off"
                   ref="variable" @keydown.down.prevent
                   @keydown.up.prevent>
            <typeahead v-model="filterModal.variable.value"
                       open-on-focus open-on-empty
                       force-select
                       :target="`#variable-${_uid}`"
                       :data="filterDictionaries.aggregate" item-key="key">
              <template slot="item" slot-scope="props">
                <li v-for="(item, index) in props.items"
                    :key="index"
                    :class="{ active: props.activeIndex === index }">
                  <a role="button" @click="props.select(item)">
                    ${{ item.key }} => {{ item.name }}
                  </a>
                </li>
              </template>
            </typeahead>
          </div>
          <div>
            <btn @click="extractFiltersFromVariable" type="warning" block>
              Appliquer
            </btn>
            <btn @click="selectAllSheets" block>
              Sélectionner toutes les fiches
            </btn>
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <h4>Liste des Filtres</h4>
          <table class="table table-responsive">
            <tbody>
              <tr>
                <th>Filtre</th>
                <th>Nom</th>
              </tr>
              <tr v-for="(value, i) in filterModal.list"
                  :key="`filter-${i}`">
                <td>
                  <btn size="xs" @click="selectFilter(i)">
                    <strong class="glyphicon glyphicon-pencil" aria-hidden="true">
                    </strong>
                  </btn>
                  <btn size="xs" @click="removeFilter(i)">
                    <strong class="glyphicon glyphicon-trash" aria-hidden="true">
                    </strong>
                  </btn>
                  {{ value.filter }}
                </td>
                <td>{{ value.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal>
    <div>
      <div class="nav">
        <btn @click="showFilterModal(columns)" type="bactADI">
          <strong class="glyphicon glyphicon-pencil" aria-hidden="true">
          </strong>&nbsp;&nbsp;
          Colonnes
        </btn>

        <btn @click="showFilterModal(rows)" type="expADI" :disabled="columns.length === 0">
          <strong class="glyphicon glyphicon-pencil" aria-hidden="true">
          </strong>&nbsp;&nbsp;
          Lignes
        </btn>

        <btn @click="invertRowsAndColumns" type="reaInfADI"
             :disabled="columns.length === 0 || rows.length === 0">
          <strong class="glyphicon glyphicon-random" aria-hidden="true">
          </strong>&nbsp;&nbsp;
          Inverser
        </btn>

        <btn @click="resetFilters" :disabled="columns.length + rows.length === 0">
          <strong class="glyphicon glyphicon-refresh" aria-hidden="true">
          </strong>
          Effacer les filtres
        </btn>

        <input :id="`characteristic-${_uid}`"
               class="characteristics-input form-control" type="text"
               v-model="characteristic.text" autocomplete="off"
               ref="viarble" @keydown.down.prevent
               @keydown.up.prevent>
        <typeahead v-model="characteristic.value"
                   open-on-focus open-on-empty
                   force-select
                   :target="`#characteristic-${_uid}`"
                   :data="availableCharacteristics">
        </typeahead>
        <btn @click="addCharacteristic()" type="primary">
          <strong class="glyphicon glyphicon-plus" aria-hidden="true">
          </strong>
          Ajouter
        </btn>
        <c-checkbox type="results" v-model="displayYearlyResults" size="sm">
          Afficher les années
        </c-checkbox>
      </div>
      <div class="text-center remove-nav">
        <btn v-for="(c, i) in characteristics" :key="`charac-${i}`" type="danger"
             @click="removeCharacteristics(i)" size="xs">
          <strong class="glyphicon glyphicon-remove" aria-hidden="true">
          </strong>
          {{ c.key }}
        </btn>
      </div>
    </div>

    <div v-if="filters.errors.length > 0">
      <div class="panel panel-danger">
        <div class="panel-heading">
          <div class="panel-title">
            Erreur : certains filtres saisis sont invalides !
          </div>
        </div>
        <div class="panel-body">
          <table class="table table-responsive table-striped">
            <tbody>
              <tr>
                <th>Emplacement</th>
                <th class="text-center">Filtre</th>
                <th class="text-center">Année</th>
                <th>Erreur</th>
              </tr>
              <tr v-for="(f, i) in filters.errors" :key="`error-${i}`">
                <td>
                  {{ f.type === 'column' ? 'Colonne' : 'Ligne' }} {{ f.index + 1 }}
                </td>
                <td class="text-center">
                  {{ f.filter }}
                </td>
                <td class="text-center">
                  {{ f.year }}
                </td>
                <td>
                  {{ f.error }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="display">
      <alert type="warning" v-if="display.errors.length > 0">
        <h4>Attention !</h4>
        <p>
          <ul>
            <li v-for="(e, i) in display.errors" :key="`error-${i}`">
              <span v-html="e"></span>
            </li>
          </ul>
        </p>
      </alert>
      <table class="table table-responsive table-striped">
        <thead>
          <tr>
            <th>
              <div v-if="!displayYearlyResults">
                <a role="button" @click="focusOnArray()">
                  Tableau entier&nbsp;
                  <strong class="glyphicon glyphicon-new-window" aria-hidden="true">
                  </strong>
                </a>
              </div>
            </th>
            <th v-for="(column, k) in columns" class="text-center txt-dark-bactADI" :key="`column-${k}`">
              <h5><strong>{{ column.name }}</strong></h5>
              <small>{{ column.filter }}</small>
              <div v-if="!displayYearlyResults">
                <div v-for="(ckey, l) in characteristics" :key="`carac-${l}`">
                  <a role="button" @click="focusOnColumn(ckey, column, k)">
                    {{ ckey.key }}&nbsp;
                    <strong class="glyphicon glyphicon-new-window" aria-hidden="true">
                    </strong>
                  </a>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in rows" class="text-center" :key="`row-${i}`">
            <th class="txt-dark-expADI">
              <h5><strong>{{ row.name }}</strong></h5>
              <small>{{ row.filter }}</small>
              <div v-if="!displayYearlyResults">
                <div v-for="(ckey, l) in characteristics" :key="`carac-${l}`">
                  <a role="button" @click="focusOnRow(ckey, row, i)">
                    {{ ckey.key }}&nbsp;
                    <strong class="glyphicon glyphicon-new-window" aria-hidden="true">
                    </strong>
                  </a>
                </div>
              </div>

            </th>
            <td v-for="(column, k) in columns" class="text-center"
                :key="`cell-${i}-${k}`">
              <template v-for="(table, t) in [display.table[k * rows.length + i]]">
                <div v-if="table.total > 0" :key="`table-${i}-${k}-${t}`">
                  <table class="table table-responsive table-condensed table-bordered">
                    <thead v-if="displayYearlyResults">
                      <tr>
                        <td>
                          <span v-if="displayYearlyResults">
                            <a role="button" class="focus-modal-link"
                               @click="focusOnCell(table, null, row, column)">
                              <strong>Toute la case</strong>&nbsp;
                              <strong class="glyphicon glyphicon-new-window" aria-hidden="true">
                              </strong>
                            </a>
                          </span>
                        </td>
                        <th class="text-center">Total</th>
                        <th v-for="(elt, u) in lists" :key="`table-${i}-${k}-l-${u}`"
                            v-if="displayYearlyResults"
                            class="text-center">
                          {{ elt.year }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="warning">
                        <th>Effectif</th>
                        <td class="text-center">{{ table.total }}</td>
                        <td class="text-center"
                            v-if="displayYearlyResults"
                            v-for="(years, u) in table.sheets"
                            :key="`table-${i}-${k}-td-${u}`">
                          {{ years.length }}
                        </td>
                      </tr>
                      <template v-for="(ckey, l) in characteristics">
                        <template v-for="(aggregate, s) in [table.aggregate[ckey.key]]"
                                  v-if="aggregate.total >0">
                          <tr class="info" :key="`table-${i}-${k}-${l}-label-${s}`">
                            <th colspan="100%" class="text-center">
                              <span v-if="displayYearlyResults">
                                <a role="button" class="focus-modal-link"
                                   @click="focusOnCell(table, ckey, row, column)">
                                  <strong>{{ ckey.key }}</strong>&nbsp;
                                  <strong class="glyphicon glyphicon-new-window" aria-hidden="true">
                                  </strong>
                                </a>
                              </span>
                              <span v-else>
                                <strong>{{ ckey.key }}</strong>
                              </span>
                            </th>
                          </tr>
                          <tr v-for="(value, key) in aggregate.values"
                              v-if="aggregate.type === 'rep' || aggregate.type === 'text'"
                              :key="`cell-${i}-${k}-${l}-${s}-${key}`">
                            <th>{{  ckey.values[key] == null ? `«${key}»` : ckey.values[key] }}</th>
                            <td class="text-center">
                                {{ value }}/{{ aggregate.total }}
                                ({{ (100 * value / aggregate.total).toFixed(2) }}%)
                            <td class="text-center"
                                v-for="(yearc, u) in table.characteristics"
                                v-if="displayYearlyResults"
                                :key="`table-${i}-${k}-${l}-${u}`">
                              <span v-if="yearc[ckey.key].total > 0">

                                {{
                                (yv = yearc[ckey.key].values[key]) == null ? 0 : yv
                                }} / {{ yearc[ckey.key].total }}
                                ({{
                                ((((yv = yearc[ckey.key].values[key]) == null ? 0 : yv) * 100) / yearc[ckey.key].total).toFixed(2)
                                }}%)
                              </span>
                            </td>
                          </tr>
                          <template v-if="aggregate.type === 'mm'">
                            <template v-for="(statistics, s) in [sc.math.statistics(aggregate.values)]">
                              <tr :key="`table-${i}-${k}-${l}-mean-${s}`">
                                <th>Moyenne</th>
                                <td class="text-center">
                                  {{ statistics.mean.toFixed(2) }}
                                </td>
                                <td class="text-center"
                                    v-for="(yearc, u) in table.characteristics"
                                    v-if="displayYearlyResults"
                                    :key="`table-${i}-${k}-${l}-${u}`">
                                  <template v-if="yearc[ckey.key].total > 0"
                                            v-for="(ystat, y) in [sc.math.statistics(yearc[ckey.key].values)]">
                                    <span :key="`table-${i}-${k}-${l}-${u}-${y}`">
                                      {{ ystat.mean.toFixed(2) }}
                                    </span>
                                  </template>
                                </td>
                              </tr>
                              <tr :key="`table-${i}-${k}-${l}-median-${s}`">
                                <th>Médiane</th>
                                <td class="text-center">
                                  {{ statistics.median.toFixed(2) }}
                                </td>
                                <td class="text-center"
                                    v-for="(yearc, u) in table.characteristics"
                                    v-if="displayYearlyResults"
                                    :key="`table-${i}-${k}-${l}-${u}`">
                                  <template v-if="yearc[ckey.key].total > 0"
                                            v-for="(ystat, y) in [sc.math.statistics(yearc[ckey.key].values)]">
                                    <span :key="`table-${i}-${k}-${l}-${u}-${y}`">
                                      {{ ystat.median.toFixed(2) }}
                                    </span>
                                  </template>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </template>
                    </tbody>
                  </table>
                </div>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import filter from '@/sui/tools/filter'
import rtti from '@/sui/tools/rtti'
import math from '@/sui/tools/math'
import assert from '@/sui/tools/assert'
import ice from '@/sui/tools/ice'
import distribution from '@/sui/data/distribution'
import suiCheckbox from '@/sui/components/checkbox'
import suiEvolCarac from '@/sui/components/evolution/caracteristics'
import clone from 'clone'

function buildFilterList (filters, dictionary, errors, type, year) {
  const result = []
  for (let i = 0; i !== filters.length; ++i) {
    const filterString = filters[i].filter
    const build = filter.build(dictionary, filterString)
    if (build.error != null) {
      errors.push(
        {
          year: year,
          type: type,
          index: i,
          filter: filterString,
          error: build.error
        }
      )

      result.push(null)
    } else {
      result.push(build)
    }
  }

  assert.equals(result.length, filters.length)
  return ice.freeze(result)
}

function listWrongSizes (context, list, expected) {
  const errors = []
  for (let i = 0; i !== list.length; ++i) {
    const count = list[i].length
    if (count !== expected) {
      errors.push(
        `${context}[${i}] size error: expected ${expected}, got ${count}`
      )
    }
  }
  return errors.length > 0 ? errors.join('\n') : null
}

function addMissingErrorIFN (errors, missing, context) {
  const values = Object.values(missing)
  let has = false
  for (let i = 0; i !== values.length; ++i) {
    if (values[i] > 0) {
      has = true
      break
    }
  }
  if (!has) {
    return
  }
  const keys = Object.keys(missing)
  const error =
    `Les filtres de <strong>${context}</strong> ne permettent pas de sélectionner toutes les fiches : <br>
     <table class='table table-responsive'>
       <tr><th>Année</th><td>${keys.join('</td><td>')}</td></tr>
       <tr><th>Fiches manquantes</th><td>${values.join('</td><td>')}</td></tr>
     </table>`
  errors.push(error)
}

function addDoubleErrorIFN (errors, doubles, filters, context) {
  function toString (i) {
    return `<span class="btn-xs btn-default">${filters[i].filter}</span> (<strong>${filters[i].name}</strong>)`
  }

  const conflicts = []
  for (let i = 0; i !== doubles.length; ++i) {
    const s = doubles[i]
    if (s.size === 0) {
      continue
    }
    const list = Array.from(s)
    let conflict = `<tr><td style="width:40%;text-align:right">${toString(i)}</td>
<td style="width:10%;text-align:center">avec</td><td>`
    for (let j = 0; j !== list.length; ++j) {
      conflict += `${toString(list[j])}<br>`
    }
    conflict += '</td>'
    conflicts.push(conflict)
  }

  if (conflicts.length === 0) {
    return
  }

  const error =
    `Certains filtres de <strong>${context}</strong> sont en conflit : <br>
     <table class='table table-responsive'>
      ${conflicts.join()}
     </table>`
  errors.push(error)
}

export default {
  name: 'result-array',

  props: {
    context: {
      type: String
    },

    data: {
      type: Array,
      required: true
    }
  },

  components: {
    'sui-evol-carac': suiEvolCarac,
    'c-checkbox': suiCheckbox
  },

  data: function () {
    return {
      displayYearlyResults: false,
      characteristics: [],
      characteristic: {
        text: '', value: null
      },
      focusModal: {
        show: false,
        sources: [],
        fieldInfo: null
      },
      filterModal: {
        edit: {
          filter: '', name: ''
        },
        variable: {
          text: '', value: null
        },
        index: null,
        show: false,
        list: null
      },
      columns: [],
      rows: [],
      cell: null,
      lists: ice.freeze(this.data),
      sc: {
        math: math
      }
    }
  },

  watch: {
    data: function (value) {
      this.lists = ice.freeze(value)
    }
  },

  computed: {
    datasetCount: function () {
      return this.lists.length
    },

    characteristicsDictionaries: function () {
      const result = []
      const complete = {}
      const errors = []
      for (let i = 0; i !== this.lists.length; ++i) {
        const dictionary = {}
        const item = this.lists[i]
        const table = item.table
        for (let j = 0; j !== table.length; ++j) {
          const category = table[j]
          for (let k = 0; k !== category.list.length; ++k) {
            const field = category.list[k]
            if (field.h) {
              continue
            }

            dictionary[field.f] = field
            const previous = complete[field.f]
            if (previous == null) {
              complete[field.f] = clone(field)
            } else if (field.v != null) {
              for (let l = 0; l !== field.v.length; ++l) {
                const value = field.v[l]
                const key = value.index != null ? value.index : value.code
                if (previous.v == null) {
                  errors.push(
                    `${item.year} - ${category.title}: Field ${field.f} has changed type.`
                  )
                  break
                }
                const found = previous.v.find(
                  l => (l.index != null ? l.index : l.code) === key
                )
                if (!found) {
                  previous.v.push(value)
                }
              }
            }
          }
        }
        result.push(dictionary)
      }

      assert(errors.length === 0, errors.join('\n'))

      return {
        aggregate: ice.freeze(complete),
        list: ice.freeze(result)
      }
    },

    filterDictionaries: function () {
      const result = []
      const complete = {}
      for (let i = 0; i !== this.lists.length; ++i) {
        const current = this.lists[i]
        const dictionary = {}
        const variables = current.variables
        for (let j = 0; j !== variables.length; ++j) {
          const v = variables[j]
          const key = `$${v.key}`
          dictionary[key] = {
            test: v.field,
            exclusive: v.exclusive
          }

          const previous = complete[key]
          if (previous != null) {
            previous.filters[i] = v
          } else {
            const newFilter = {
              key: v.key,
              name: v.name,
              filters: {}
            }
            newFilter.filters[i] = v
            complete[key] = newFilter
          }
        }
        result.push(dictionary)
      }

      const aggregate = []
      for (let key in complete) {
        aggregate.push(complete[key])
      }
      assert.equals(result.length, this.datasetCount)
      return {
        aggregate: ice.freeze(aggregate),
        list: ice.freeze(result)
      }
    },

    filters: function () {
      const errors = []
      const list = []
      for (let i = 0; i !== this.datasetCount; ++i) {
        const dictionary = this.filterDictionaries.list[i]
        const dset = this.lists[i]

        const columns = buildFilterList(
          this.columns, dictionary, errors, 'column', dset.year
        )
        const rows = buildFilterList(
          this.rows, dictionary, errors, 'row', dset.year
        )

        list.push({ rows, columns })
      }
      assert.equals(list.length, this.datasetCount)

      const final = {
        errors,
        list
      }
      return ice.freeze(final)
    },

    sheetsByColumns: function () {
      const { errors, list } = this.filters
      if (this.columns.length === 0 || (errors != null && errors.length > 0)) {
        return null
      }

      const result = new Array(this.columns.length)
      const doubles = new Array(this.columns.length)
      for (let i = 0; i !== this.columns.length; ++i) {
        const data = new Array(this.lists.length)
        for (let j = 0; j !== this.lists.length; ++j) {
          data[j] = []
        }
        result[i] = data
        doubles[i] = new Set()
      }

      const missing = {}
      for (let i = 0; i !== this.datasetCount; ++i) {
        const dataset = this.lists[i]
        missing[dataset.year] = 0

        const filterList = list[i].columns
        const sheets = dataset.list
        for (let j = 0; j !== sheets.length; ++j) {
          const sheet = sheets[j]

          let found = -1
          for (let k = 0; k !== filterList.length; ++k) {
            const fc = filterList[k]
            if (fc(sheet)) {
              if (found < 0) {
                result[k][i].push(sheet)
                found = k
              } else {
                const d = doubles[found]
                d.add(k)
              }
            }
          }

          if (found < 0) {
            ++missing[dataset.year]
          }
        }
      }
      assert.equals(result.length, this.columns.length, 'Different size')
      assert(() => listWrongSizes('sheetsByColumns', result, this.datasetCount), 'listWrongSizes')

      const final = {
        doubles,
        missing,
        list: ice.freeze(result)
      }
      return final
    },

    sheetsByCells: function () {
      const { errors, list } = this.filters
      if ((this.rows.length === 0 || this.sheetsByColumns == null) ||
          (errors != null && errors.length > 0)) {
        return null
      }

      const doubles = new Array(this.rows.length)
      const cells = new Array(this.rows.length * this.columns.length)
      for (let i = 0; i !== this.rows.length; ++i) {
        doubles[i] = new Set()
        for (let j = 0; j !== this.columns.length; ++j) {
          const years = new Array(this.datasetCount)
          for (let k = 0; k !== this.datasetCount; ++k) {
            years[k] = []
          }
          cells[i * this.columns.length + j] = years
        }
      }

      const missing = {}
      for (let i = 0; i !== this.datasetCount; ++i) {
        const dataset = this.lists[i]
        const datasetFilters = list[i].rows
        missing[dataset.year] = 0

        for (let j = 0; j !== this.columns.length; ++j) {
          const sheets = this.sheetsByColumns.list[j][i]
          for (let k = 0; k !== sheets.length; ++k) {
            const sheet = sheets[k]

            let found = -1
            for (let l = 0; l !== datasetFilters.length; ++l) {
              const f = datasetFilters[l]

              if (f(sheet)) {
                if (found < 0) {
                  const index = j * this.rows.length + l
                  cells[index][i].push(sheet)
                  found = l
                } else {
                  const d = doubles[found]
                  d.add(l)
                }
              }
            }
            if (found < 0) {
              ++missing[dataset.year]
            }
          }
        }
      }
      assert.equals(cells.length, this.rows.length * this.columns.length)
      assert(() => listWrongSizes('sheetsByCells', cells, this.datasetCount))
      const final = {
        doubles,
        missing,
        cells: ice.freeze(cells)
      }
      return final
    },

    characteristicsByCells: function () {
      if (this.sheetsByCells == null) {
        return null
      }

      const sbc = this.sheetsByCells.cells
      if (sbc == null) {
        return null
      }

      const result = new Array(sbc.length)
      for (let i = 0; i !== sbc.length; ++i) {
        const dsetCells = sbc[i]
        const list = new Array(dsetCells.length)
        for (let j = 0; j !== dsetCells.length; ++j) {
          const sheets = dsetCells[j]
          const config = this.lists[j]

          try {
            const dist = distribution(
              config.dist,
              sheets,
              config.year
            )
            list[j] = ice.freeze(dist)
          } catch (e) {
            this.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
            })
            list[j] = {}
          }
        }
        result[i] = list
      }
      assert.equals(result.length, sbc.length)
      assert(() => listWrongSizes('characteristicsByCells', result, this.datasetCount))
      return ice.freeze(result)
    },

    display: function () {
      if (this.sheetsByColumns == null) {
        return null
      }

      if (this.sheetsByCells == null || this.characteristicsByCells == null) {
        const errors = []
        addMissingErrorIFN(errors, this.sheetsByColumns.missing, 'colonnes')
        addDoubleErrorIFN(
          errors, this.sheetsByColumns.doubles, this.columns, 'colonnes'
        )

        return { errors }
      }

      const table = []

      for (let i = 0; i !== this.sheetsByCells.cells.length; ++i) {
        const sheetsByDataset = this.sheetsByCells.cells[i]
        const characteristicsByDataset = this.characteristicsByCells[i]

        let total = 0
        const aggregate = {}
        for (let j = 0; j !== this.datasetCount; ++j) {
          const sheets = sheetsByDataset[j]
          total += sheets.length

          const characteristics = characteristicsByDataset[j]
          for (let k in characteristics) {
            const previous = aggregate[k]
            const current = characteristics[k]
            if (previous == null) {
              if (current.type === 'rep' || current.type === 'text') {
                aggregate[k] = {
                  total: current.total,
                  values: clone(current.values),
                  type: current.type
                }
              } else if (current.type === 'mm') {
                aggregate[k] = {
                  total: current.total,
                  sum: current.sum,
                  type: current.type,
                  values: [...current.values]
                }
              } else {
                assert.isNull(current.type, `Unknown type: ${current.type}`)
              }
              continue
            }
            assert(
              previous == null || previous.type === current.type,
              `Different types ${previous.type} ${current.type}`
            )

            previous.total += current.total
            if (previous.type === 'rep' || previous.type === 'text') {
              for (let i in current.values) {
                if (previous.values[i] == null) {
                  previous.values[i] = 0
                }
                previous.values[i] += current.values[i]
              }
            } else if (previous.type === 'mm') {
              previous.sum += current.sum
              previous.values.push(...current.values)
            }
          }
        }

        table.push(
          ice.freeze(
            {
              sheets: sheetsByDataset,
              characteristics: characteristicsByDataset,
              total: total,
              aggregate: aggregate
            }
          )
        )
      }
      assert.equals(table.length, this.rows.length * this.columns.length)

      const errors = []
      addMissingErrorIFN(errors, this.sheetsByColumns.missing, 'colonnes')
      addMissingErrorIFN(errors, this.sheetsByCells.missing, 'lignes')

      addDoubleErrorIFN(
        errors, this.sheetsByColumns.doubles, this.columns, 'colonnes'
      )
      addDoubleErrorIFN(
        errors, this.sheetsByCells.doubles, this.rows, 'lignes'
      )
      const final = {
        errors,
        table: ice.freeze(table)
      }

      return final
    },

    availableCharacteristics: function () {
      const result = []
      if (this.characteristicsByCells == null) {
        return result
      }

      const cbc = this.characteristicsByCells
      const done = new Set()
      for (let i = 0; i !== cbc.length; ++i) {
        const list = cbc[i]
        for (let j = 0; j !== list.length; ++j) {
          const elt = list[j]
          for (let key in elt) {
            if (!done.has(key)) {
              done.add(key)
              result.push(key)
            }
          }
        }
      }

      return result
    }
  },

  methods: {
    focusOnCell: function (table, ckey, row, column) {
      const sources = []
      const title = `«<strong>${row.name}</strong>» et «<strong>${column.name}</strong>»`
      const prefix = this.context !== '' ? `${this.context} et ` : ''
      const filter = `${prefix}(${row.filter}) et (${column.filter})`

      const info = ckey != null
        ? this.characteristicsDictionaries.aggregate[ckey.key]
        : {
          f: 'counter',
          t: `Évolution du nombre de fiches avec ${title}`,
          v: [{ code: 0, value: `Fiches avec ${row.name} et ${column.name}` }]
        }
      assert(table.characteristics.length === table.sheets.length)
      for (let i = 0; i !== table.characteristics.length; ++i) {
        const yearData = table.characteristics[i]
        assert.notNull(yearData.year)
        sources.push(
          {
            year: yearData.year,
            dist: ckey != null ? yearData
              : {
                counter: {
                  total: table.sheets[i].length,
                  type: 'rep',
                  values: { 0: table.sheets[i].length }
                }
              }
          }
        )
      }

      const fieldInfo = {
        field: info,
        title: title,
        subtitle: `<i>${filter}</i>`
      }
      this.showFocusModal(sources, fieldInfo)
    },

    focusOnRow: function (ckey, row, index) {
      const info = this.characteristicsDictionaries.aggregate[ckey.key]
      const sources = []
      const step = this.rows.length
      for (let i = 0; i !== this.columns.length; ++i) {
        const tableIndex = index + i * step
        const table = this.display.table[tableIndex]
        const col = this.columns[i]
        sources.push(
          { year: col.name, dist: table.aggregate }
        )
      }

      const prefix = this.context !== '' ? `${this.context} et ` : ''
      const fieldInfo = {
        field: info,
        title: `«<strong>${row.name}</strong>»`,
        subtitle: `<i>${prefix}(${row.filter})</i>`
      }
      this.showFocusModal(sources, fieldInfo)
    },

    focusOnArray: function () {
      const sources = []
      for (let i = 0; i !== this.columns.length; ++i) {
        const column = this.columns[i]
        let total = 0
        const values = {}
        for (let j = 0; j !== this.rows.length; ++j) {
          const cellIndex = i * this.rows.length + j
          const cell = this.display.table[cellIndex]
          const count = cell.total

          values[j] = count
          total += count
        }

        sources.push(
          {
            year: column.name,
            dist: { counter: { total: total, type: 'rep', values: values } }
          }
        )
      }

      const v = []
      for (let i = 0; i !== this.rows.length; ++i) {
        v.push({ code: i, value: this.rows[i].name })
      }

      const fieldInfo = {
        field: {
          f: 'counter',
          t: 'Effectifs',
          v: v
        },
        title: `«<strong>Tableau entier</strong>»`,
        subtitle: `<i>${this.context}</i>`
      }
      this.showFocusModal(sources, fieldInfo)
    },

    focusOnColumn: function (ckey, column, k) {
      const info = this.characteristicsDictionaries.aggregate[ckey.key]
      const sources = []
      const firstTableIndex = k * this.rows.length
      for (let i = 0; i !== this.rows.length; ++i) {
        const tableIndex = firstTableIndex + i
        const table = this.display.table[tableIndex]
        const row = this.rows[i]
        sources.push(
          { year: row.name, dist: table.aggregate }
        )
      }

      const prefix = this.context !== '' ? `${this.context} et ` : ''
      const fieldInfo = {
        field: info,
        title: `«<strong>${column.name}</strong>»`,
        subtitle: `<i>${prefix}(${column.filter})</i>`
      }
      this.showFocusModal(sources, fieldInfo)
    },

    showFocusModal: function (sources, fieldInfo) {
      this.focusModal.sources = sources
      this.focusModal.fieldInfo = fieldInfo
      this.focusModal.show = true
    },

    resetFilters: function () {
      this.rows.splice(0, this.rows.length)
      this.columns.splice(0, this.columns.length)
    },

    updateArray: function (msg) {
      if (msg === 'ok') {
        this.filterModal.source.splice(
          0, this.filterModal.source.length,
          ...this.filterModal.list
        )
      }
    },

    removeCharacteristics: function (i) {
      this.characteristics.splice(i, 1)
    },

    addCharacteristic: function () {
      const key = this.characteristic.value
      if (key == null) {
        return
      }

      const reference = this.characteristicsDictionaries.aggregate[key]
      const values = {}
      if (reference.v != null) {
        for (let i = 0; i !== reference.v.length; ++i) {
          const value = reference.v[i]
          const key = value.index != null ? value.index : value.code
          values[key] = value.value
        }
      }

      this.characteristics.push({ key, values })
    },

    selectAllSheets: function () {
      const { list } = this.filterModal
      list.length = 0
      list.push({ filter: `$id ~ .`, name: 'Toutes les fiches' })
    },

    extractFiltersFromVariable: function () {
      const { value } = this.filterModal.variable
      if (value == null) {
        return
      }

      const { list } = this.filterModal
      list.length = 0
      const extractedValues = new Set()

      for (let i = 0; i !== this.lists.length; ++i) {
        const sheets = this.lists[i].list
        const characteristics = this.characteristicsDictionaries.list[i]

        const currentFilter = value.filters[i]
        assert.notNull(currentFilter)
        const labels = {}
        if (currentFilter.characs != null && currentFilter.characs.length > 0) {
          for (let k = 0; k !== currentFilter.characs.length; ++k) {
            const charac = currentFilter.characs[k]
            const associated = characteristics[charac]
            if (associated != null) {
              for (let i = 0; i !== associated.v.length; ++i) {
                const v = associated.v[i]
                assert(
                  labels[v.code] == null || labels[v.code] === v.value,
                  `Different label for the same code (${v.code}) ${charac}: ${labels[v.code]} != ${v.value}`
                )
                labels[v.code] = v.value
              }
            }
          }
        }

        for (let j = 0; j !== sheets.length; ++j) {
          const isFunction = rtti.isFunction(currentFilter.field)
          const sheet = sheets[j]
          const values = isFunction
            ? currentFilter.field(sheet)
            : (sheet[currentFilter.field] != null ? [sheet[currentFilter.field]] : null)
          for (let k = 0; k !== values.length; ++k) {
            const v = values[k]
            if (v !== null && !extractedValues.has(v)) {
              extractedValues.add(v)
              let name = labels[v]
              if (name == null) {
                name = v
              }

              list.push({ filter: `$${currentFilter.key} : "${v}"`, name: name })
            }
          }
        }
      }
      list.sort((a, b) => a.name > b.name)
    },

    showFilterModal: function (list) {
      this.filterModal.list = clone(list)
      this.filterModal.source = list
      this.filterModal.index = null
      this.filterModal.edit.filter = ''
      this.filterModal.edit.name = ''
      this.filterModal.show = true
      this.filterModal.variable.text = ''
      this.filterModal.variable.value = null
    },

    invertRowsAndColumns: function () {
      [this.rows, this.columns] = [this.columns, this.rows]
    },

    saveFilter: function () {
      const { index, list, edit } = this.filterModal
      if (edit.name === '' || edit.filter === '') {
        return
      }

      if (index != null) {
        list[index].name = edit.name
        list[index].filter = edit.filter
      } else {
        list.push({ name: edit.name, filter: edit.filter })
      }
      this.filterModal.index = null
      this.filterModal.edit.name = this.filterModal.edit.filter = ''
    },

    selectFilter: function (i) {
      this.filterModal.index = i
      const item = this.filterModal.list[i]
      this.filterModal.edit.name = item.name
      this.filterModal.edit.filter = item.filter
    },

    removeFilter: function (i) {
      this.$delete(this.filterModal.list, i)
      if (this.filterModal.index >= i) {
        this.filterModal.index = null
      }
    }

  }
}
</script>
<style scoped lang="less">
@import '~variables';

.nav {
  margin-top: 2rem;
  justify-content: center;
  display: flex;
  flex-direction: row;

  .btn, input, .c-checkbox {
    margin: 0.2rem;
  }
}

.table {
  h5 {
    margin: 0.1rem;
  }

  hr {
    margin: 0.05rem;
  }

  th > td {
    text-align: center;
  }

  tr > td {
    color: darken(@brand-primary, 20%);

    a {
      color: darken(@brand-primary, 20%);
    }
  }
}

.remove-nav {
  margin-bottom: 1rem;
  .btn {
    margin: 0.2rem;
  }
}

.characteristics-input {
  width: 12rem;
}
</style>
